import React, { useRef } from "react";
import { MapPin } from "lucide-react";
import { Autocomplete } from "@react-google-maps/api";
import { useGoogleReady, GMAPS_KEY } from "../lib/gmaps";

// Start typing a postcode/address → scroll & select a real UK address (Google Places).
const AddressAutocomplete = ({ value, onChange, onSelect, placeholder = "Enter postcode or address" }) => {
  const isLoaded = useGoogleReady();
  const acRef = useRef(null);

  const handlePlace = () => {
    const place = acRef.current?.getPlace();
    if (!place) return;
    const comps = place.address_components || [];
    const get = (t) => comps.find((c) => c.types.includes(t))?.long_name || "";
    const postcode = get("postal_code");
    const address = place.formatted_address || place.name || "";
    onSelect?.({ address, postcode, lat: place.geometry?.location?.lat(), lng: place.geometry?.location?.lng() });
  };

  const inputEl = (
    <div className="relative">
      <MapPin size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#b8935f] z-10" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid="address-autocomplete-input"
        className="w-full h-[54px] pl-11 pr-4 rounded-lg border border-[#e2d8c8] text-[15px] outline-none focus:ring-2 focus:ring-[#b8935f]/30 focus:border-[#b8935f] transition"
      />
    </div>
  );

  if (!isLoaded || !GMAPS_KEY) return inputEl;
  return (
    <Autocomplete
      onLoad={(ac) => { acRef.current = ac; }}
      onPlaceChanged={handlePlace}
      options={{ types: ["address"], componentRestrictions: { country: "gb" }, fields: ["address_components", "formatted_address", "geometry", "name"] }}
    >
      {inputEl}
    </Autocomplete>
  );
};

export default AddressAutocomplete;
